import DocumentsScreen from './DocumentsScreen';

export default DocumentsScreen;
